"use client";

import { BenefitsSection } from "@/components/marketing/what-is-hub/BenefitsSection";
import { ContactSection } from "@/components/marketing/what-is-hub/ContactSection";
import { CoreFeatures } from "@/components/marketing/what-is-hub/CoreFeatures";
import { Footer } from "@/components/marketing/what-is-hub/Footer";
import { Header } from "@/components/marketing/what-is-hub/Header";
import { Hero } from "@/components/marketing/what-is-hub/Hero";
import { PlatformVisual } from "@/components/marketing/what-is-hub/PlatformVisual";

export default function WhatIsHubPage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      <Hero />
      <PlatformVisual />
      <CoreFeatures />
      <BenefitsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
